import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M5.40021 21C5.22964 21.0028 5.06007 20.9736 4.90021 20.914L12.9542 12.857L15.6202 15.526L6.36521 20.726C6.07205 20.8979 5.73993 20.9922 5.40021 21ZM4.23621 20.335C4.07249 20.0385 3.99101 19.7036 4.00021 19.365V4.66004C3.99886 4.43682 4.03261 4.21478 4.10021 4.00204L12.3332 12.237L4.23321 20.337L4.23621 20.335ZM16.4152 15.077L13.5742 12.238L16.7072 9.10604L19.4902 10.669C20.0244 10.9081 20.3819 11.4239 20.4182 12.008C20.3821 12.5928 20.0241 13.1091 19.4892 13.348L16.4152 15.077ZM12.9542 11.614L4.61421 3.27504C4.8432 3.10572 5.12042 3.01424 5.40521 3.01404C5.74155 3.02598 6.06968 3.12116 6.36021 3.29104L15.9112 8.65904L12.9552 11.614H12.9542Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "PlayStore"
);
